<script setup lang="ts">
withDefaults(defineProps<{
  label: string
  inputCount?: number
}>(), {
  inputCount: 2,
})
</script>

<template>
  <div class="form-skeleton" aria-busy="true" :aria-label="label">
    <div class="skeleton-line skeleton-title" />
    <div class="skeleton-content">
      <div
        v-for="inputIndex in inputCount"
        :key="inputIndex"
        class="skeleton-line skeleton-input"
      />
      <div class="skeleton-line skeleton-textarea" />
    </div>
    <div class="skeleton-footer">
      <div class="skeleton-line skeleton-btn" />
      <div class="skeleton-line skeleton-btn" />
    </div>
  </div>
</template>

<style scoped lang="scss">
@use "~/assets/scss/partials/components/entity-form" as *;
</style>
